import { languageMap } from ".."

languageMap.gap = {
	comments: {
		line: "#",
	},
}
